module.exports = __webpack_public_path__ + "img/security-and-compliance.69eb39f9.svg";